_getExtendedOptions